(ns practitest.frontend.milestone.readiness-index.subs
  (:require [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.routing.router :as router]
            [practitest.frontend.milestone.readiness-index :as-alias ri]
            [practitest.frontend.milestones :as-alias milestones]
            [clojure.core.match :refer [match]]
            [re-frame.core :as rf]))

(def metrics
  #:metrics
  {:ccs  "Coverage Confidence"
   :ecs  "Execution Confidence"
   :rdrs "Remaining Defects Risk"})

(def metrics->tab
  #:metrics
  {:ccs  :requirements
   :ecs  :testsets
   :rdrs :issues})

(defn- score->level [score]
  (when (some? score)
    (condp < score
      0.75 :high
      0.50 :medium
      :low)))

(defn badge [{:keys           [metrics/trimester]
              ::ri/keys       [data-unavailable? rrqi-level]
              :milestone/keys [upcoming? past?]}]
  (let [ri-was-not-calculated
        {:text    "Score is not calculated"
         :tooltip "Release Readiness was not calculated for milestones
 completed before the feature was enabled."}]
    (when-not upcoming?
      (if (and past? data-unavailable?)
        ri-was-not-calculated
        (let [stage (if (<=  trimester 2) :early :late)]
          {:text
           (match [stage rrqi-level]
             [_ :medium]    "Needs Attention"
             [:early :low]  "Needs Attention"
             [:early :high] "On Track"
             [:late :low]   "Off Track"
             [:late :high]  "Ready"
             :else "")})))))

(defn- url-for
  [milestone & [{:keys [tab]
                 :or   {tab :general}}]]
  (router/get-href2 ::milestones/edit milestone {} {:tab tab}))

(defn- prepare-metrics [milestone]
  (for [[metric label] metrics
        :let [score (some-> milestone metric (.toFixed 1))
              tab   (metrics->tab metric)]]
    {:label       label
     :url         (url-for milestone {:tab tab})
     :score       score
     :score-level (score->level score)}))

(rf/reg-sub
 ::milestone
 (fn [[_ id] _]
   (rf/subscribe [::milestones/milestone id]))
 (fn [{:milestone/keys [upcoming?]
       :keys           [delete-confirmation-required?]
       :as             milestone} _]
   (let [milestone (cond-> milestone
                     upcoming? (dissoc :metrics/ccs :metrics/ecs
                                       :metrics/rdrs :metrics/rrqi))
         rrqi      (:metrics/rrqi milestone)
         enriched  (merge milestone
                          {::ri/data-unavailable?         (nil? rrqi)
                           ::ri/rrqi-level                (score->level rrqi)
                           :delete-confirmation-required? delete-confirmation-required?
                           :url                           (url-for milestone)
                           :metrics                       (prepare-metrics milestone)})]
     (assoc enriched ::ri/badge (badge enriched)))))

